import Vue from 'vue'

export default function Component (id, definition) {
  const {components, template, render, props} = definition

  if (props) {
    Object.keys(props).forEach(key => {
      const prop = props[key]
      const {valid} = prop

      if (valid) {
        prop.validator = value => valid.includes(value)
      }
    })
  }

  if (components) {
    definition.components = componentsByName(components)
  }

  if (!template && !render) {
    definition.render = renderEmpty
  }

  if (template && template.render) {
    delete definition.template

    Object.assign(definition, template)
  }

  const component = Vue.component(id, definition)

  return component.options
}

function componentsByName (components) {
  let byName = {}

  if (Array.isArray(components)) {
    components.forEach(component => {
      byName[component.name] = component
    })
  } else {
    byName = components
  }

  return byName
}

function renderEmpty (createElement, context = this) {
  return context._v('')
}
